import React from 'react';
import { getApi } from '../../api/endpoints.js';
import uiManager from '../../../config/ui.js';
import UI_ACTIONS from '../../data/UiActionConstants';
import UiAction from '../../components/UiAction';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faRotate } from "@fortawesome/free-solid-svg-icons";
import { useNavigate, useParams } from 'react-router-dom'
import ListingPageComponent from '../../components/ListingPageComponent.js';
import PAGES from '../../data/PagesConstants.js';

const Listing = (props) => {
  const defaultHeaderConfig = { disableSort: true };
  const navigate = useNavigate()
  const params = useParams()

  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'ID',
      attr: 'id',
      disableSort: false
    },
    {
      ...defaultHeaderConfig,
      label: 'Name',
      attr: 'name',
    },
    {
      ...defaultHeaderConfig,
      label: 'Tenure',
      attr: 'tenure',
    },
    {
      ...defaultHeaderConfig,
      label: 'Emi Amount',
      attr: 'tenure',
    },
    {
      ...defaultHeaderConfig,
      label: 'Total Lease Amount',
      attr: 'lease_amount',
    },
    {
      disableSort: true,
      label: 'Actions',
      value: (row) => {
        return <div style={{ display: 'flex', justifyContent: 'space-around' }}>
          <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.update_lease_offer.name)}>
            <div style={{ cursor: 'pointer' }} onClick={(e) => onEditClick(row.id)}>
              <FontAwesomeIcon icon={faEdit} />
            </div>
          </UiAction>
          <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.roll_over_configs_for_lease_offer.name)}>
            <div style={{ cursor: 'pointer' }} onClick={(e) => onRollOverClick(row.id)}>
              <span className='border p-1 rounded'>
                <span className='mx-1'>
                  <FontAwesomeIcon icon={faRotate} />
                </span>
                <span className='mx-1'>
                  Rollover Configs
                </span>
              </span>
            </div>
          </UiAction>
        </div>
      }
    }
  ]

  const onRollOverClick = (id) => {
    navigate(`/fleet_owners/${params.id}/lease_offers/${id}/rollover_configs`);
  }

  const tableHeaderActionsComponent = () => {
    return <React.Fragment>
      <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.create_lease_offer.name)}>
        <button className="s-btn me-2" style={{ width: "150px" }} onClick={onNewClick}>
          <span>Add New Lease Offer</span>
        </button>
      </UiAction>
    </React.Fragment>
  }

  const onNewClick = () => {
    navigate(`/fleet_owners/${params.id}/lease_offers/new`);
  }

  const onEditClick = (id) => {
    navigate(`/fleet_owners/${params.id}/lease_offers/${id}/edit`)
  }

  // return <ListingComponent
  //   key={"PAGES.LeaseOfferListingTab.name"}
  //   contentHeading="Lease Offer List - Results"
  //   listingMutation={getApi('leaseOffers')}
  //   className="lease_offers_listing"
  //   headers={headers}
  //   recordsKey="lease_offers"
  //   params= {props.defaultParams}
  //   tableHeaderActionsComponent={tableHeaderActionsComponent()}
  //   searchBy={['Name']}
  // />

  return <ListingPageComponent
  key={PAGES.LeaseOfferListingTab.name}
  uiPage={uiManager.getUiPage(PAGES.LeaseOfferListingTab.name)}
  // breadcrumbs={[{ label: 'Home', url: '/dashboard' }, { label: 'Lease Offers' }]}
  listingMutation={getApi('leaseOffers')}
  className="lease_offers_listing"
  contentHeading="Lease Offer List - Results"
  headers={headers}
  recordsKey="lease_offers"
  searchBy={['Name']}
  params= {props.defaultParams}
  tableHeaderActionsComponent={tableHeaderActionsComponent()}
/>
};

export default Listing;